import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=0c9c50b2&scoped=true&"
import script from "./PhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./PhoneNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9c50b2",
  null
  
)

export default component.exports